module.exports = __webpack_public_path__ + "img/acFlow2.b5ad40b0.gif";